module.exports = __webpack_public_path__ + "img/avaliacoesFill.853f28e2.svg";